import dotProp from 'dot-prop-immutable'
import { connect } from 'react-redux'
import FrameMenu from '../../components/FrameMenu'
import Copy from './Copy'
import Remove from './Remove'
import Resize from './Resize'
import Rotate from './Rotate'
import SelectFrame from './SelectFrame'
import SelectPhoto from './SelectPhoto'
import Split from './Split'
import Crop from './Crop'
import MergeSet from './MergeSet'

const mapStateToProps = selectedName => state => ({
  show: dotProp.get(state, 'project.selectedObject', '') === selectedName,
  isSidebarOpen: dotProp.get(state, 'sidebar.isClosed', false),
})
const mapDispatchToProps = () => ({})

export const FrameMenuForFrames = connect(
  mapStateToProps('frame'),
  mapDispatchToProps
)(FrameMenu)

export const FrameMenuForSets = connect(
  mapStateToProps('set'),
  mapDispatchToProps
)(FrameMenu)

export { Copy, Crop, Remove, Resize, Rotate, SelectPhoto, SelectFrame, Split, MergeSet, FrameMenu }



// WEBPACK FOOTER //
// ./src/containers/FrameMenu/index.js